/*
 * ⌥⌘B (Ctrl+Alt+B) shows and hides the Casey panel: the editor-style
 * "secondary side bar" chord, next to ⌘B for the app's own sidebar.
 */
import { useEffect } from "react";

import { isApplePlatform } from "@/features/globalSearch/GlobalSearchTrigger";

import { ideLayoutStore } from "./ideLayoutStore";

export const isCaseyShortcut = (
  e: Pick<
    KeyboardEvent,
    "code" | "metaKey" | "ctrlKey" | "altKey" | "shiftKey" | "repeat"
  >
): boolean =>
  e.code === "KeyB" &&
  (e.metaKey || e.ctrlKey) &&
  e.altKey &&
  !e.shiftKey &&
  !e.repeat;

export const caseyShortcutLabel = (): string =>
  isApplePlatform() ? "⌥⌘B" : "Ctrl+Alt+B";

export const caseyShortcutKeys = (): string =>
  isApplePlatform() ? "Meta+Alt+B" : "Control+Alt+B";

/** Bind the chord while the IDE is mounted. */
export const useCaseyShortcut = (): void => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!isCaseyShortcut(e)) return;
      e.preventDefault();
      ideLayoutStore.toggle("right");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
};
